import { Checkbox, Grid, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { InputProps, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonSave from "../../unit/CustomButtonSave";
import CustomSelect from "../../unit/forms/CustomSelect";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import CustomControlMoneyEditTextField from "../../unit/forms/CustomControlMoneyEditTextField";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const CustomToNotifyDisbursementDialog = (props: any) => {
  const record = props.record;
  const appId = record?.id;
  const loan = record?.loan;
  const appAttrs = record?.attrs;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [show3rdparty, setShow3rdparty] = useState(false);
  const refresh = useRefresh();
  const [amountLoan, setAmountLoan] = useState(
    record.loanAmount ? record.loanAmount : record.amountReview
  );
  const [amountPaidBorrower, setAmountPaidBorrower] = useState(
    appAttrs.amount_paid_borrower
  );
  const [amountPaidExistingLoan, setAmountPaidExistingLoan] = useState(
    appAttrs.amount_paid_existingloan
  );
  const [amountPaid3party, setAmountPaid3party] = useState(
    appAttrs.amount_paid_3party
  );
  const [partyType, setPartyType] = useState(appAttrs?.party_type || "");
  const [partyName, setPartyName] = useState(appAttrs?.party_name || "");
  const [partyPhone, setPartyPhone] = useState(appAttrs?.party_phone || "");
  const [partyEmail, setPartyEmail] = useState(appAttrs?.party_email || "");
  const [partyReceivingBank, setPartyReceivingBank] = useState(
    appAttrs?.party_receiving_bank || ""
  );
  const [partyAccountHolder, setPartyAccountHolder] = useState(
    appAttrs?.party_account_holder || ""
  );
  const [partyAccountType, setPartyAccountType] = useState(
    appAttrs?.party_account_type || ""
  );
  const [partyAccountRoutingNumber, setPartyAccountRoutingNumber] = useState(
    appAttrs?.party_account_routing_number || ""
  );
  const [partyAccountNumber, setPartyAccountNumber] = useState(
    appAttrs?.party_account_number || ""
  );
  const [processPayment, setProcessPayment] = useState(
    !!appAttrs?.process_payment
  );
  useEffect(() => {
    let cal3rdAmount = amountLoan - amountPaidBorrower - amountPaidExistingLoan;
    setAmountPaid3party(cal3rdAmount > 0 ? cal3rdAmount : 0);
  }, [amountLoan, amountPaidBorrower, amountPaidExistingLoan]);

  useEffect(() => {
    if (amountPaid3party > 0) {
      setShow3rdparty(true);
    } else {
      setShow3rdparty(false);
    }
  }, [amountPaid3party]);

  const defaultPartyType: { label: any; value: any }[] = [];
  defaultPartyType.push({
    label: "Close Out Existing Loan",
    value: "Close Out Existing Loan",
  });
  defaultPartyType.push({ label: "Individual", value: "Individual Seller" });
  defaultPartyType.push({
    label: "Individual Landlord",
    value: "Individual Landlord",
  });
  defaultPartyType.push({
    label: "Financing Company",
    value: "Financing Company",
  });
  defaultPartyType.push({
    label: "Vehicle Dealer Company",
    value: "Vehicle Dealer Company",
  });
  defaultPartyType.push({
    label: "Merchandise Company",
    value: "Merchandise Company",
  });
  defaultPartyType.push({
    label: "Property Management Company",
    value: "Property Management Company",
  });
  defaultPartyType.push({
    label: "Professional Services Provider",
    value: "Professional Services Provider",
  });
  defaultPartyType.push({
    label: "Educational Institution",
    value: "Educational Institution",
  });
  defaultPartyType.push({ label: "Other", value: "Other" });

  const defaultPartyAccountType: { label: any; value: any }[] = [];
  defaultPartyAccountType.push({ label: "Checking", value: "Checking" });
  defaultPartyAccountType.push({ label: "Savings", value: "Savings" });
  defaultPartyAccountType.push({
    label: "Business Checking",
    value: "Business Checking",
  });

  const handleSaveDisbursement = async () => {
    const formJson = {
      loanamount: amountLoan,
      amount_paid_borrower: amountPaidBorrower,
      amount_paid_existingloan: amountPaidExistingLoan,
      amount_paid_3party: amountPaid3party,
      party_type: partyType,
      party_name: partyName,
      party_phone: partyPhone,
      party_email: partyEmail,
      party_receiving_bank: partyReceivingBank,
      party_account_holder: partyAccountHolder,
      party_account_type: partyAccountType,
      party_account_routing_number: partyAccountRoutingNumber,
      party_account_number: partyAccountNumber,
      process_payment: processPayment,
    };

    const reqUrl = `applications/actions/notify/disbursement`;
    const response = await sendRequest(reqUrl, { id: appId, data: formJson });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Disbursement Data saved successfully");
      refresh();
    } else {
      errorNotify(response?.message || "Data not saved!");
    }
  };

  return (
    <>
      <Grid container sx={{ mb: 2, pb: 2 }}>
        {/* save button */}
        <Grid
          container
          sx={{
            position: "sticky",
            top: "25px",
            zIndex: 2,
            justifyContent: "flex-end",
            // backgroundColor: "#fff",
            pb: 1,
          }}
        >
          <Grid item>
            <CustomButtonSave
              type="submit"
              className="btn btn-primary"
              variant="contained"
              label="Save"
              onClick={handleSaveDisbursement}
            />
          </Grid>
        </Grid>
        {/* Loan Number */}
        <Grid sx={{ mb: 2 }} container>
          <Grid item xs={5} sx={{ pt: 1 }}>
            <HeaderLabelTitle title="Loan Amount" />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="loanAmount"
              name="loanAmount"
              variant="outlined"
              value={amountLoan}
              className="amountText"
              sx={{
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                  borderRadius: "10px",
                },
                "& input": { pl: "0px", pt: "8px" },
              }}
              InputProps={{
                readOnly: true,
                startAdornment: <AttachMoneyIcon sx={{ fontSize: "16px" }} />,
              }}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        {/* Amount Paid To Borrower */}
        <Grid sx={{ mb: 2 }} container>
          <Grid item xs={5} sx={{ pt: 1 }}>
            <HeaderLabelTitle title="Amount Paid To Borrower" />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="amount_paid_borrower"
              name="amount_paid_borrower"
              variant="outlined"
              value={amountPaidBorrower}
              required
              onChange={(e) => {
                setAmountPaidBorrower(e.target.value);
              }}
              className="amountText"
              sx={{
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                  borderRadius: "10px",
                },
                "& input": { pl: "0px", pt: "8px" },
              }}
              InputProps={{
                startAdornment: <AttachMoneyIcon sx={{ fontSize: "16px" }} />,
              }}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        <Grid sx={{ mb: 2 }} container>
          <Grid item xs={5} sx={{ pt: 1 }}>
            <HeaderLabelTitle title="Amount To Pay Off Existing Loan" />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="amount_paid_existingloan"
              name="amount_paid_existingloan"
              variant="outlined"
              value={amountPaidExistingLoan}
              onChange={(e) => {
                setAmountPaidExistingLoan(e.target.value);
              }}
              className="amountText"
              sx={{
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                  borderRadius: "10px",
                },
                "& input": { pl: "0px", pt: "8px" },
              }}
              InputProps={{
                startAdornment: <AttachMoneyIcon sx={{ fontSize: "16px" }} />,
              }}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        {/* Amount Paid To 3rd Party */}
        <Grid sx={{ mb: 2 }} container>
          <Grid item xs={5} sx={{ pt: 1 }}>
            <HeaderLabelTitle title="Amount Paid To 3rd Party" />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="amount_paid_3party"
              name="amount_paid_3party"
              variant="outlined"
              value={amountPaid3party}
              // InputProps={{ readOnly: true } as InputProps}
              // sx={{ backgroundColor: "#ddd" }}
              className="amountText"
              sx={{
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                  borderRadius: "10px",
                },
                "& input": { pl: "0px", pt: "8px" },
              }}
              InputProps={{
                readOnly: true,
                startAdornment: <AttachMoneyIcon sx={{ fontSize: "16px" }} />,
              }}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        {show3rdparty && (
          <>
            {/* 3rd party Type */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Type" />
              </Grid>
              <Grid item xs={5}>
                <CustomSelect
                  fullWidth={true}
                  variant="outlined"
                  id="party_type"
                  name="party_type"
                  value={partyType}
                  optionlist={defaultPartyType}
                  required={true}
                  onChange={(e: any) => {
                    setPartyType(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>

            {/* 3rd Party Name: */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Name" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_name"
                  name="party_name"
                  variant="outlined"
                  value={partyName}
                  onChange={(e) => {
                    setPartyName(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Part Phone */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Phone" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_phone"
                  name="party_phone"
                  variant="outlined"
                  value={partyPhone}
                  className="numericText"
                  onChange={(e) => {
                    setPartyPhone(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Email */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Email" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_email"
                  name="party_email"
                  variant="outlined"
                  value={partyEmail}
                  onChange={(e) => {
                    setPartyEmail(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Receiving Bank Name */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Receiving Bank Name" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_receiving_bank"
                  name="party_receiving_bank"
                  variant="outlined"
                  value={partyReceivingBank}
                  onChange={(e) => {
                    setPartyReceivingBank(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Account Holder Name */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Account Holder Name" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_account_holder"
                  name="party_account_holder"
                  variant="outlined"
                  value={partyAccountHolder}
                  onChange={(e) => {
                    setPartyAccountHolder(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Account Type:*/}

            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Account Type" />
              </Grid>
              <Grid item xs={5}>
                <CustomSelect
                  fullWidth={true}
                  variant="outlined"
                  id="party_account_type"
                  name="party_account_type"
                  value={partyAccountType}
                  optionlist={defaultPartyAccountType}
                  required={true}
                  onChange={(e: any) => {
                    setPartyAccountType(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Routing Number: */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Routing Number" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_account_routing_number"
                  name="party_account_routing_number"
                  variant="outlined"
                  value={partyAccountRoutingNumber}
                  className="numericText"
                  onChange={(e) => {
                    setPartyAccountRoutingNumber(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
            {/* 3rd Party Account Number: */}
            <Grid sx={{ mb: 2 }} container>
              <Grid item xs={5} sx={{ pt: 1 }}>
                <HeaderLabelTitle title="3rd Party Account Number" />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  id="party_account_number"
                  name="party_account_number"
                  variant="outlined"
                  value={partyAccountNumber}
                  className="numericText"
                  onChange={(e) => {
                    setPartyAccountNumber(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={2}></Grid>
            </Grid>
          </>
        )}
        {/* Process payment to 3rd Party on Happy Mango, checkbox */}
        <Grid sx={{ mb: 2 }} container>
          <Grid item xs={5} sx={{ pt: 1 }}>
            <HeaderLabelTitle title="Process payment to 3rd Party on Happy Mango" />
          </Grid>
          <Grid item xs={5}>
            {/* old logic, this field can't need check,  */}
            <Checkbox
              id="process_payment"
              name="process_payment"
              // checked={processPayment}
              checked={false}
              onChange={(e) => {
                setProcessPayment(e.target.checked);
              }}
              disabled={true}
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>
        {/* end form */}
      </Grid>
    </>
  );
};

export default CustomToNotifyDisbursementDialog;
